const tech_img = require('../../assets/img/tutorials/paisaje/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/paisaje/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/paisaje/func.png');
const secondary_func_img = require('../../assets/img/tutorials/paisaje/secondary-func.png');

export const PaisajeLuzSteps = [
    {
        name: 'Paisaje de la Luz',
        title: 'Descripción funcional',
        description: <span>
            <p>El gemelo digital muestra la ubicación de distintos monumentos, edificios y árboles singulares que se integran en el Paisaje de la Luz.</p>
            <p>Ilustra la <b>integración eficiente de diversas fuentes de datos</b>, incluyendo la sensórica de ruido ambiental y otros factores, y la <b>aplicación de simulaciones avanzadas</b> con el objetivo de optimizar la gestión y planificación en ambientes urbanos y naturales, mejorando así la calidad de vida y la sostenibilidad del entorno.</p>
            </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Cultura, Turismo y Deporte</p>
            <p>Área de Gobierno de Urbanismo, Medio Ambiente y Movilidad</p>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
            </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Paisaje de la Luz',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Modelado 3D y Visualización</b>: Utilización de plataformas para el tratamiento y análisis de datos geoespaciales así como modelos 3D.</li>
                    <li><b>Simulación y Análisis</b>: Implementación de motores de simulación para el modelado de ruido ambiental y factores climáticos que impactan en el entorno urbano y natural.</li>
                    <li><b>Sensórica y Datos en Tiempo Real</b>: Integración de sensores IoT para la recolección de datos ambientales en tiempo real.</li>
                </ul>
            </span>
            <span>
                Origen de datos
                <ul>
                    <li>Modelos 3D  e información histórica y actualizada de bases de datos urbanísticas y <b>registros de patrimonio</b> para la localización de monumentos y árboles singulares</li>
                    <li>Datos recopilados directamente de sensores ambientales, incluyendo niveles de ruido, temperatura, humedad y calidad del aire.</li>
                </ul>
            </span>
            </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];